import React from 'react';

interface ArrowDropDownTapProps {
  size?: string | number;
  color?: string;
}

const ArrowDropDownTap = ({ size = '20', color = '#CE181E' }: ArrowDropDownTapProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 20 20"
    >
      <path d="M15 5L1 5L8 12L15 5Z" fill={color} />
    </svg>
  );
};

export default ArrowDropDownTap;
